import React, { Dispatch, SetStateAction, useState } from "react";
import { FaqDetailLabel, FaqDetailRow } from "../ManageFaqDetailInput";
import Flex from "../../../../../DefaultStyles/Flex";
import { OptionType } from "../../../../../Filters/DropDown";
import styled from "styled-components";
import LineBtn from "../../../../../Button/LineBtn";
import FaqServiceSelectModal from "./FaqServiceSelect/FaqServiceSelectModal";

interface FaqServiceSelectProps {
  isEditMode?: boolean;
  subsId: OptionType[] | null;
  setSubsId: Dispatch<SetStateAction<OptionType[] | null>>;
}

export default function FaqServiceSelect({
  isEditMode,
  subsId,
  setSubsId,
}: FaqServiceSelectProps) {
  const [selectServiceModal, setSelectServiceModal] = useState(false);

  return (
    <>
      <FaqDetailRow style={{ padding: "8px 0" }}>
        <FaqDetailLabel>서비스 선택</FaqDetailLabel>

        <Flex style={{ width: "calc(100% - 148px)" }} gapSize={12}>
          {subsId && subsId?.length > 0 ? (
            <FaqSearchContainer>
              {subsId?.map((a) => (
                <FaqSearchKeyword
                  isEditMode={Boolean(isEditMode)}
                  onClick={() => {
                    if (isEditMode)
                      setSubsId((prev) => [
                        ...(prev?.filter((p) => p?.value !== a?.value) || []),
                      ]);
                  }}
                >
                  {a.label}
                  <Icon className="material-icons-outlined">close</Icon>
                </FaqSearchKeyword>
              ))}
            </FaqSearchContainer>
          ) : (
            <></>
          )}

          <>
            {isEditMode && (
              <LineBtn
                btnText="서비스 선택"
                icon="add_circle"
                btnHeight={38}
                btnClickEvent={() => setSelectServiceModal(true)}
              />
            )}
          </>
        </Flex>
      </FaqDetailRow>

      {selectServiceModal && (
        <FaqServiceSelectModal
          closeEvent={() => setSelectServiceModal(false)}
          saveSubsList={(list) => setSubsId(list)}
          selectedList={subsId ?? []}
        />
      )}
    </>
  );
}

const FaqSearchContainer = styled.div`
  width: 100%;
  border-radius: 3px;
  background-color: #f6f6f8;
  padding: 6px 16px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
`;

const FaqSearchKeyword = styled.span<{ isEditMode: boolean }>`
  cursor: ${({ isEditMode }) => (isEditMode ? "pointer" : "default")};
  padding: 4px 8px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.buttonColor.lineNormal};
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 14px;
  font-weight: bold;
  line-height: 21px;
  color: ${({ theme }) => theme.color.gray700};
`;

const Icon = styled.span`
  font-size: 14px;
  color: #505050;
`;
